import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ModalOverlayRef } from 'src/app/modal/modal-overlay-ref';

const SURVEY_URLS: Record<string, string> = {
  pl: 'https://forms.gle/EasoTXxksDyPv3cc8',
  en: 'https://forms.gle/QnN4s9qGu8owiupe6',
  de: 'https://forms.gle/tMPTNQ7HTeGiChTe7',
  es: 'https://forms.gle/To9aHd9dgjJRD8TA6',
  fr: 'https://forms.gle/PbALwxd6M3acCQxM6',
  ru: 'https://forms.gle/GtXqvC3tsjQLeKJM6',
  tr: 'https://forms.gle/MaGkqKN2DR8A7x4a9',
  cz: 'https://forms.gle/rFCJAwMEGAHpLVkS8',
};

const DISMISSED_KEY = 'customerResearchPopupDismissed';

@Component({
  selector: 'gl-customer-research-popup',
  templateUrl: './customer-research-popup.component.html',
  styleUrls: ['./customer-research-popup.component.scss'],
  standalone: false,
})
export class CustomerResearchPopupComponent {
  constructor(private modalRef: ModalOverlayRef, private translate: TranslateService) {
    this.modalRef.subscribeBackdrop(() => this.close());
  }

  public openSurvey(): void {
    const lang = this.translate.currentLang;
    const surveyUrl = SURVEY_URLS[lang] ?? SURVEY_URLS.en;
    this.dismiss();
    window.open(surveyUrl, '_blank');
  }

  public close(): void {
    this.dismiss();
  }

  private dismiss(): void {
    localStorage.setItem(DISMISSED_KEY, 'true');
    this.modalRef.close();
  }
}
